module.exports = __webpack_public_path__ + "fonts/MavenPro-Light-100.b78f7bcb.otf";